import type { JobResultSnack } from './JobProgressStepper';

/**
 * How long the result snackbar may stay up, in ms — `null` means it never
 * auto-hides. Shared by both StopStart buttons so the sticky rule lives in ONE
 * place: gating on `snack.remaining` instead reads `0` (a clean book) and `null`
 * (a book nobody could read) as the same falsy value, and auto-hides the second
 * one after 8s — the outcome that most needs the operator to see it.
 *
 * Its own module so the component file keeps exporting components: this is the
 * one piece of the snack contract a non-component consumer reaches for.
 */
export const jobSnackAutoHideMs = (
  snack: JobResultSnack | null
): number | null => (snack?.cancelUnresolved ? null : 8000);
